/* eslint-disable react/display-name */
import React from "react";

export type WidgetPreviewContextValue = {
  width: number | string;
  height: number;
  url: string;
};

const WidgetPreviewContext = React.createContext<
  WidgetPreviewContextValue | undefined
>(undefined);

export default WidgetPreviewContext;

type WithWidgetPreviewContextProps = {
  previewContext?: WidgetPreviewContextValue;
};

export const withWidgetPreviewContext = <P extends object>(
  Element: React.ComponentType<P & WithWidgetPreviewContextProps>
) => {
  return (props: P) => (
    <WidgetPreviewContext.Consumer>
      {(previewContext) => (
        <Element previewContext={previewContext} {...props} />
      )}
    </WidgetPreviewContext.Consumer>
  );
};